import { render } from "./HeroiconsSolidEye.vue?vue&type=template&id=3f043938"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidEye.vue"]])

export default __exports__